import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_crossesSecondary",
  "use": "icon_crossesSecondary-usage",
  "viewBox": "0 0 136 107",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 136 107\" id=\"icon_crossesSecondary\"><path d=\"M112 98.39h8.565v8.126h6.598v-8.127h8.483v-6.267h-8.483v-8.127h-6.598v8.126H112v6.268z\" fill=\"#41C69B\" /><path d=\"M0 98.392h8.565v8.127h6.598v-8.127h8.482v-6.268h-8.482v-8.126H8.565v8.126H0v6.268z\" fill=\"#02293B\" /><path d=\"M34.065 23.48h13.973v13.261h10.764v-13.26h13.84V13.26h-13.84V0H48.038v13.26H34.065v10.22z\" fill=\"#ED2074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol